<template>
  <div
    class="bottom-drawer wrapper"
    @click="handleOverlayClick"
    aria-modal="true"
    role="dialog"
    aria-labelledby="modal-title"
  >
    <div class="bottom-drawer__content" @click.stop>
      <header class="bottom-drawer__header">
        <h5 class="bottom-drawer__header-title" id="modal-title">{{ title }}</h5>
        <button @click="closeModal" aria-label="Close modal" class="bottom-drawer__close-cta">
          <svg class="toast__close-icon">
            <use xlink:href="#icon-cross"></use>
          </svg>
        </button>
      </header>
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, onUnmounted } from 'vue';

  const props = defineProps({
    title: {
      type: String,
      default: '',
    },
    onCloseModal: {
      type: Function,
      default: () => {},
    },
  });

  onMounted(() => {
    document.body.style.overflow = 'hidden';
  });

  onUnmounted(() => {
    document.body.style.overflow = '';
  });

  const closeModal = () => {
    props.onCloseModal();
  };

  // Close the modal when clicking outside of the modal content
  const handleOverlayClick = (event) => {
    // Close the modal only if the overlay (background) is clicked
    if (event.target === event.currentTarget) {
      closeModal();
    }
  };
</script>
